class AddToCartClickFunction {
    init() {
        if (!this.isInitialized) {
            this.isInitialized = true;
            function showPopup(pHeading, pMessage, isSuccess, lblViewCart, urlViewCart) {
                $(".add-cart-section").parents(".modal-open").addClass("addCart-success");
                var msg = '<div class="cart-success-msg">' +
                    '<h4>' + pHeading + '</h4>' +
                    '<p>' + pMessage + '</p>' +
                    '</div>';
                if (isSuccess) {
                    msg = msg + '<div><h5><a href="' + urlViewCart+'">' + lblViewCart+'</a></h5></div>';
                }
                $(".add-cart-section").parents(".modal-open").find(".ekko-lightbox .modal-body").html(msg);
            }

            $(document).on("click",
                ".btn-addCart",
                function () {
                    $(this).parents('.modal-open').find('.modal-content').css('max-height', '150px');
                    var loadingHtml =
                        '<div class="template-ajax-loading" style="padding:0"><span class="icon-ajax-loader"></span><p>Loading...</p></div>';
                    $(this).parents('.modal-open').find('.modal-body').html(loadingHtml);
                    var divAddCartSection = $(this).closest('.add-cart-section');

                    if (divAddCartSection.length) {
                        var sku = divAddCartSection.data("sku");
                        var name = divAddCartSection.data("name");
                        var index = divAddCartSection.data("partidentifier");
                        var reqFrom = divAddCartSection.data("callfrom");

                        var qtyOrdered;
                        if (divAddCartSection.find("[name='quantity']").length) {
                            qtyOrdered = divAddCartSection.find("[name='quantity']").val();
                        } else {
                            qtyOrdered = 1;
                        }

                        var unitOfMeasure = divAddCartSection.data("unit");
                        var languageCode = $('html')[0].lang;
                        var successMsgHeading = divAddCartSection.data("satclabel");
                        var failureMsgHeading = divAddCartSection.data("fatclabel");
                        var viewCartLabel = divAddCartSection.data("viewcartlabel");
                        var viewCartUrl = $('.viewcart-url').attr('href');

                        var shortDesc = divAddCartSection.data("sdsca");
                        var price = divAddCartSection.data("price");
                        let currencyCode=divAddCartSection.data("currencycode")
                        var request = {
                            "Sku": sku,
                            "QtyOrdered": qtyOrdered,
                            "UnitOfMeasure": unitOfMeasure,
                            "LanguageCode": languageCode
                        };

                        $.ajax({
                            url: '/b2c-api/addtocart',
                            data: request,
                            accept: 'application/json; charset=utf-8',
                            dataType: 'json',
                            xhrFields: {
                                withCredentials: true
                            },
                            success: function (data, textStatus, xhr) {
                                var cookies = data.CookieCollection;
                               /* if (cookies) {
                                    jQuery.each(cookies, function (i, cookie) {
                                        setCookie(cookie.Value.Name, cookie.Value.Value, cookie.Value.Expires, cookie.Value.Domain);
                                    });
                                } */
                                if (data.TotalItems >= 0) {
                                    $(".header__cart-items").removeAttr("style");
                                    $('.header__cart-items').text(data.TotalItems);
                                    showPopup(successMsgHeading, data.Message, true,viewCartLabel,viewCartUrl);
                                }
                                else {
                                    showPopup(failureMsgHeading, data.Message, false, viewCartLabel, viewCartUrl);
                                }
                            },
                            error: function (XMLHttpRequest, textStatus, errorThrown) {
                                var errorMessage = 'Call Failed';
                                showPopup(failureMsgHeading, errorMessage, false, viewCartLabel, viewCartUrl);
                            }
                        });
                          /*   
                        if (reqFrom === "partdetailaccess" || reqFrom === "partdetailAssemblyDraw") {
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [{
                                        item_name: shortDesc,
                                        item_id: name,
                                        price: price,
                                        item_list_name: "Parts Assembly Drawing List",
                                        index: index,
                                        quantity: qtyOrdered,
                                        currency:currencyCode
                                    }]
                                }
                            });
                        } else {
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: shortDesc,
                                            item_id: name,
                                            price: price,
                                            quantity: qtyOrdered,
                                            currency :currencyCode
                                        }
                                    ]
                                }
                            });
                        }  */
                    }
                });
        }
    }
}

export default new AddToCartClickFunction();